module.exports = __webpack_public_path__ + "media/hyper/images/logo-light-3b724a41c26b1913211a33b811a5cce4.png";